import utils from '../utils';

const fundList = () => ({
  getFundsList: (url: string) => utils.fetch(url),
  getFundsListUrl: (searchInput: string) => `http://localhost:3002/fundList?searchInput=${searchInput}`,
});

export default fundList;
